import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=a4b88bec&scoped=true&"
import script from "./sendMessage.vue?vue&type=script&lang=js&"
export * from "./sendMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b88bec",
  null
  
)

export default component.exports